const license = {
    not_installed: 'На этом экземпляре лицензия не установлена.',
    invalid_key: 'Лицензионный ключ недействителен или был изменён.',
    expired_key: 'Срок действия лицензионного ключа истёк. Получите новый ключ и установите его снова.',
};
export default Object.freeze(license);
